"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AddAllocationRequest = /** @class */ (function () {
    function AddAllocationRequest() {
    }
    return AddAllocationRequest;
}());
exports.AddAllocationRequest = AddAllocationRequest;
var AddDateRuleRequest = /** @class */ (function () {
    function AddDateRuleRequest() {
    }
    return AddDateRuleRequest;
}());
exports.AddDateRuleRequest = AddDateRuleRequest;
var AddDateRuleProductInstanceRequest = /** @class */ (function (_super) {
    __extends(AddDateRuleProductInstanceRequest, _super);
    function AddDateRuleProductInstanceRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AddDateRuleProductInstanceRequest;
}(AddDateRuleRequest));
exports.AddDateRuleProductInstanceRequest = AddDateRuleProductInstanceRequest;
var AddDefinitionOutcomeRequest = /** @class */ (function () {
    function AddDefinitionOutcomeRequest() {
    }
    return AddDefinitionOutcomeRequest;
}());
exports.AddDefinitionOutcomeRequest = AddDefinitionOutcomeRequest;
var AddDeliverableOutcomeRequest = /** @class */ (function () {
    function AddDeliverableOutcomeRequest() {
    }
    return AddDeliverableOutcomeRequest;
}());
exports.AddDeliverableOutcomeRequest = AddDeliverableOutcomeRequest;
var RoleHintRequest = /** @class */ (function () {
    function RoleHintRequest() {
    }
    return RoleHintRequest;
}());
exports.RoleHintRequest = RoleHintRequest;
var AddFixedContractLineRequest = /** @class */ (function () {
    function AddFixedContractLineRequest() {
    }
    return AddFixedContractLineRequest;
}());
exports.AddFixedContractLineRequest = AddFixedContractLineRequest;
var AddProvisionalContractLineRequest = /** @class */ (function () {
    function AddProvisionalContractLineRequest() {
    }
    return AddProvisionalContractLineRequest;
}());
exports.AddProvisionalContractLineRequest = AddProvisionalContractLineRequest;
var AddInstanceOutcomeRequest = /** @class */ (function () {
    function AddInstanceOutcomeRequest() {
    }
    return AddInstanceOutcomeRequest;
}());
exports.AddInstanceOutcomeRequest = AddInstanceOutcomeRequest;
var AddProductClassRequest = /** @class */ (function () {
    function AddProductClassRequest() {
    }
    return AddProductClassRequest;
}());
exports.AddProductClassRequest = AddProductClassRequest;
var UpdateTagRequest = /** @class */ (function () {
    function UpdateTagRequest() {
    }
    return UpdateTagRequest;
}());
exports.UpdateTagRequest = UpdateTagRequest;
var AddPhaseRequest = /** @class */ (function () {
    function AddPhaseRequest() {
    }
    return AddPhaseRequest;
}());
exports.AddPhaseRequest = AddPhaseRequest;
var ApprovalFeedbackRequest = /** @class */ (function () {
    function ApprovalFeedbackRequest() {
    }
    return ApprovalFeedbackRequest;
}());
exports.ApprovalFeedbackRequest = ApprovalFeedbackRequest;
var ChangeProductRoleRequest = /** @class */ (function () {
    function ChangeProductRoleRequest() {
    }
    return ChangeProductRoleRequest;
}());
exports.ChangeProductRoleRequest = ChangeProductRoleRequest;
var AddProductInstancePhaseRequest = /** @class */ (function () {
    function AddProductInstancePhaseRequest() {
    }
    return AddProductInstancePhaseRequest;
}());
exports.AddProductInstancePhaseRequest = AddProductInstancePhaseRequest;
var AddProductPhaseRequest = /** @class */ (function () {
    function AddProductPhaseRequest() {
    }
    return AddProductPhaseRequest;
}());
exports.AddProductPhaseRequest = AddProductPhaseRequest;
var AddRollingContractLineRequest = /** @class */ (function () {
    function AddRollingContractLineRequest() {
    }
    return AddRollingContractLineRequest;
}());
exports.AddRollingContractLineRequest = AddRollingContractLineRequest;
var AddUnitRuleRequest = /** @class */ (function () {
    function AddUnitRuleRequest() {
    }
    return AddUnitRuleRequest;
}());
exports.AddUnitRuleRequest = AddUnitRuleRequest;
var AddUnitRuleProductInstanceRequest = /** @class */ (function (_super) {
    __extends(AddUnitRuleProductInstanceRequest, _super);
    function AddUnitRuleProductInstanceRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AddUnitRuleProductInstanceRequest;
}(AddUnitRuleRequest));
exports.AddUnitRuleProductInstanceRequest = AddUnitRuleProductInstanceRequest;
var AddWorkRequest = /** @class */ (function () {
    function AddWorkRequest() {
    }
    return AddWorkRequest;
}());
exports.AddWorkRequest = AddWorkRequest;
var AdjustDeliverableTermRequest = /** @class */ (function () {
    function AdjustDeliverableTermRequest() {
        this.cascade = true;
    }
    return AdjustDeliverableTermRequest;
}());
exports.AdjustDeliverableTermRequest = AdjustDeliverableTermRequest;
var AdjustBulkDatesRequest = /** @class */ (function () {
    function AdjustBulkDatesRequest() {
    }
    return AdjustBulkDatesRequest;
}());
exports.AdjustBulkDatesRequest = AdjustBulkDatesRequest;
var AmendAllocationRequest = /** @class */ (function () {
    function AmendAllocationRequest() {
    }
    return AmendAllocationRequest;
}());
exports.AmendAllocationRequest = AmendAllocationRequest;
var AmendDateRuleRequest = /** @class */ (function (_super) {
    __extends(AmendDateRuleRequest, _super);
    function AmendDateRuleRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AmendDateRuleRequest;
}(AddDateRuleRequest));
exports.AmendDateRuleRequest = AmendDateRuleRequest;
var AmendDateRuleProductInstanceRequest = /** @class */ (function (_super) {
    __extends(AmendDateRuleProductInstanceRequest, _super);
    function AmendDateRuleProductInstanceRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AmendDateRuleProductInstanceRequest;
}(AmendDateRuleRequest));
exports.AmendDateRuleProductInstanceRequest = AmendDateRuleProductInstanceRequest;
var AmendDefinitionOutcomeRequest = /** @class */ (function () {
    function AmendDefinitionOutcomeRequest() {
    }
    return AmendDefinitionOutcomeRequest;
}());
exports.AmendDefinitionOutcomeRequest = AmendDefinitionOutcomeRequest;
var AmendDeliverableOutcomeRequest = /** @class */ (function () {
    function AmendDeliverableOutcomeRequest() {
    }
    return AmendDeliverableOutcomeRequest;
}());
exports.AmendDeliverableOutcomeRequest = AmendDeliverableOutcomeRequest;
var AmendInstanceOutcomeRequest = /** @class */ (function () {
    function AmendInstanceOutcomeRequest() {
    }
    return AmendInstanceOutcomeRequest;
}());
exports.AmendInstanceOutcomeRequest = AmendInstanceOutcomeRequest;
var AmendPhaseTermRequest = /** @class */ (function () {
    function AmendPhaseTermRequest() {
        this.cascade = true;
    }
    return AmendPhaseTermRequest;
}());
exports.AmendPhaseTermRequest = AmendPhaseTermRequest;
var TerminateRollingLineRequest = /** @class */ (function () {
    function TerminateRollingLineRequest() {
    }
    return TerminateRollingLineRequest;
}());
exports.TerminateRollingLineRequest = TerminateRollingLineRequest;
var TerminateRollingContractRequest = /** @class */ (function () {
    function TerminateRollingContractRequest() {
    }
    return TerminateRollingContractRequest;
}());
exports.TerminateRollingContractRequest = TerminateRollingContractRequest;
var AmendProductDefinitionRequest = /** @class */ (function () {
    function AmendProductDefinitionRequest() {
    }
    return AmendProductDefinitionRequest;
}());
exports.AmendProductDefinitionRequest = AmendProductDefinitionRequest;
var AmendProductInstancePhaseRequest = /** @class */ (function () {
    function AmendProductInstancePhaseRequest() {
    }
    return AmendProductInstancePhaseRequest;
}());
exports.AmendProductInstancePhaseRequest = AmendProductInstancePhaseRequest;
var AmendProductPhaseRequest = /** @class */ (function () {
    function AmendProductPhaseRequest() {
    }
    return AmendProductPhaseRequest;
}());
exports.AmendProductPhaseRequest = AmendProductPhaseRequest;
var AmendUnitRuleRequest = /** @class */ (function (_super) {
    __extends(AmendUnitRuleRequest, _super);
    function AmendUnitRuleRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AmendUnitRuleRequest;
}(AddUnitRuleRequest));
exports.AmendUnitRuleRequest = AmendUnitRuleRequest;
var AmendUnitRuleProductInstanceRequest = /** @class */ (function (_super) {
    __extends(AmendUnitRuleProductInstanceRequest, _super);
    function AmendUnitRuleProductInstanceRequest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AmendUnitRuleProductInstanceRequest;
}(AmendUnitRuleRequest));
exports.AmendUnitRuleProductInstanceRequest = AmendUnitRuleProductInstanceRequest;
var AmendWorkTypeRequest = /** @class */ (function () {
    function AmendWorkTypeRequest() {
    }
    return AmendWorkTypeRequest;
}());
exports.AmendWorkTypeRequest = AmendWorkTypeRequest;
var CreateDeliverableOutcomeRequest = /** @class */ (function () {
    function CreateDeliverableOutcomeRequest() {
    }
    return CreateDeliverableOutcomeRequest;
}());
exports.CreateDeliverableOutcomeRequest = CreateDeliverableOutcomeRequest;
var CreateFixedContractRequest = /** @class */ (function () {
    function CreateFixedContractRequest() {
    }
    return CreateFixedContractRequest;
}());
exports.CreateFixedContractRequest = CreateFixedContractRequest;
var CreateOrganizationRequest = /** @class */ (function () {
    function CreateOrganizationRequest() {
    }
    return CreateOrganizationRequest;
}());
exports.CreateOrganizationRequest = CreateOrganizationRequest;
var CreateArticleFromOutcomeRequest = /** @class */ (function () {
    function CreateArticleFromOutcomeRequest() {
    }
    return CreateArticleFromOutcomeRequest;
}());
exports.CreateArticleFromOutcomeRequest = CreateArticleFromOutcomeRequest;
var LinkArticleToOutcomeRequest = /** @class */ (function () {
    function LinkArticleToOutcomeRequest() {
    }
    return LinkArticleToOutcomeRequest;
}());
exports.LinkArticleToOutcomeRequest = LinkArticleToOutcomeRequest;
var UnlinkArticleFromOutcomeRequest = /** @class */ (function () {
    function UnlinkArticleFromOutcomeRequest() {
    }
    return UnlinkArticleFromOutcomeRequest;
}());
exports.UnlinkArticleFromOutcomeRequest = UnlinkArticleFromOutcomeRequest;
var CreateFullDeliverableRequest = /** @class */ (function () {
    function CreateFullDeliverableRequest() {
    }
    return CreateFullDeliverableRequest;
}());
exports.CreateFullDeliverableRequest = CreateFullDeliverableRequest;
var CreatePartialDeliverableRequest = /** @class */ (function () {
    function CreatePartialDeliverableRequest() {
    }
    return CreatePartialDeliverableRequest;
}());
exports.CreatePartialDeliverableRequest = CreatePartialDeliverableRequest;
var CreateMultiDeliverableRequest = /** @class */ (function () {
    function CreateMultiDeliverableRequest() {
    }
    return CreateMultiDeliverableRequest;
}());
exports.CreateMultiDeliverableRequest = CreateMultiDeliverableRequest;
var CreateProductDefinitionRequest = /** @class */ (function () {
    function CreateProductDefinitionRequest() {
    }
    return CreateProductDefinitionRequest;
}());
exports.CreateProductDefinitionRequest = CreateProductDefinitionRequest;
var CreateProductClassRequest = /** @class */ (function () {
    function CreateProductClassRequest() {
    }
    return CreateProductClassRequest;
}());
exports.CreateProductClassRequest = CreateProductClassRequest;
var CreateRollingContractRequest = /** @class */ (function () {
    function CreateRollingContractRequest() {
    }
    return CreateRollingContractRequest;
}());
exports.CreateRollingContractRequest = CreateRollingContractRequest;
var CreateWorkTypeRequest = /** @class */ (function () {
    function CreateWorkTypeRequest() {
    }
    return CreateWorkTypeRequest;
}());
exports.CreateWorkTypeRequest = CreateWorkTypeRequest;
var DuplicateProductDefinitionRequest = /** @class */ (function () {
    function DuplicateProductDefinitionRequest() {
    }
    return DuplicateProductDefinitionRequest;
}());
exports.DuplicateProductDefinitionRequest = DuplicateProductDefinitionRequest;
var GenerateProductInstanceTermRequest = /** @class */ (function () {
    function GenerateProductInstanceTermRequest() {
    }
    return GenerateProductInstanceTermRequest;
}());
exports.GenerateProductInstanceTermRequest = GenerateProductInstanceTermRequest;
var GenerateTermRequest = /** @class */ (function () {
    function GenerateTermRequest() {
    }
    return GenerateTermRequest;
}());
exports.GenerateTermRequest = GenerateTermRequest;
var GetDeliverableWorkToDoRequest = /** @class */ (function () {
    function GetDeliverableWorkToDoRequest() {
    }
    return GetDeliverableWorkToDoRequest;
}());
exports.GetDeliverableWorkToDoRequest = GetDeliverableWorkToDoRequest;
var LockDeliverableTermRequest = /** @class */ (function () {
    function LockDeliverableTermRequest() {
    }
    return LockDeliverableTermRequest;
}());
exports.LockDeliverableTermRequest = LockDeliverableTermRequest;
var LockPhaseTermRequest = /** @class */ (function () {
    function LockPhaseTermRequest() {
    }
    return LockPhaseTermRequest;
}());
exports.LockPhaseTermRequest = LockPhaseTermRequest;
var MarkDeliverableCompleteRequest = /** @class */ (function () {
    function MarkDeliverableCompleteRequest() {
    }
    return MarkDeliverableCompleteRequest;
}());
exports.MarkDeliverableCompleteRequest = MarkDeliverableCompleteRequest;
var MarkDeliverableStartedRequest = /** @class */ (function () {
    function MarkDeliverableStartedRequest() {
    }
    return MarkDeliverableStartedRequest;
}());
exports.MarkDeliverableStartedRequest = MarkDeliverableStartedRequest;
var RemoveAllocationRequest = /** @class */ (function () {
    function RemoveAllocationRequest() {
    }
    return RemoveAllocationRequest;
}());
exports.RemoveAllocationRequest = RemoveAllocationRequest;
var RemoveDateRuleRequest = /** @class */ (function () {
    function RemoveDateRuleRequest() {
    }
    return RemoveDateRuleRequest;
}());
exports.RemoveDateRuleRequest = RemoveDateRuleRequest;
var RemoveDefinitionOutcomeRequest = /** @class */ (function () {
    function RemoveDefinitionOutcomeRequest() {
    }
    return RemoveDefinitionOutcomeRequest;
}());
exports.RemoveDefinitionOutcomeRequest = RemoveDefinitionOutcomeRequest;
var RemoveDeliverableOutcomeRequest = /** @class */ (function () {
    function RemoveDeliverableOutcomeRequest() {
    }
    return RemoveDeliverableOutcomeRequest;
}());
exports.RemoveDeliverableOutcomeRequest = RemoveDeliverableOutcomeRequest;
var RemoveInstanceOutcomeRequest = /** @class */ (function () {
    function RemoveInstanceOutcomeRequest() {
    }
    return RemoveInstanceOutcomeRequest;
}());
exports.RemoveInstanceOutcomeRequest = RemoveInstanceOutcomeRequest;
var RemovePhaseRequest = /** @class */ (function () {
    function RemovePhaseRequest() {
    }
    return RemovePhaseRequest;
}());
exports.RemovePhaseRequest = RemovePhaseRequest;
var RemoveProductInstancePhaseRequest = /** @class */ (function () {
    function RemoveProductInstancePhaseRequest() {
    }
    return RemoveProductInstancePhaseRequest;
}());
exports.RemoveProductInstancePhaseRequest = RemoveProductInstancePhaseRequest;
var RemoveProductPhaseRequest = /** @class */ (function () {
    function RemoveProductPhaseRequest() {
    }
    return RemoveProductPhaseRequest;
}());
exports.RemoveProductPhaseRequest = RemoveProductPhaseRequest;
var RemoveProductRuleRequest = /** @class */ (function () {
    function RemoveProductRuleRequest() {
    }
    return RemoveProductRuleRequest;
}());
exports.RemoveProductRuleRequest = RemoveProductRuleRequest;
var RemoveUnitRuleRequest = /** @class */ (function () {
    function RemoveUnitRuleRequest() {
    }
    return RemoveUnitRuleRequest;
}());
exports.RemoveUnitRuleRequest = RemoveUnitRuleRequest;
var RequestDateChangeRequest = /** @class */ (function () {
    function RequestDateChangeRequest() {
    }
    return RequestDateChangeRequest;
}());
exports.RequestDateChangeRequest = RequestDateChangeRequest;
var SetOutcomeRequest = /** @class */ (function () {
    function SetOutcomeRequest() {
    }
    return SetOutcomeRequest;
}());
exports.SetOutcomeRequest = SetOutcomeRequest;
var TransferOwnerRequest = /** @class */ (function () {
    function TransferOwnerRequest() {
    }
    return TransferOwnerRequest;
}());
exports.TransferOwnerRequest = TransferOwnerRequest;
var UpdateDeliverableOutcomeRequest = /** @class */ (function () {
    function UpdateDeliverableOutcomeRequest() {
    }
    return UpdateDeliverableOutcomeRequest;
}());
exports.UpdateDeliverableOutcomeRequest = UpdateDeliverableOutcomeRequest;
var UpdateDeliverableRequest = /** @class */ (function () {
    function UpdateDeliverableRequest() {
    }
    return UpdateDeliverableRequest;
}());
exports.UpdateDeliverableRequest = UpdateDeliverableRequest;
var UpgradeProductInstanceRequest = /** @class */ (function () {
    function UpgradeProductInstanceRequest() {
    }
    return UpgradeProductInstanceRequest;
}());
exports.UpgradeProductInstanceRequest = UpgradeProductInstanceRequest;
var UpgradeProductPhaseRequest = /** @class */ (function () {
    function UpgradeProductPhaseRequest() {
    }
    return UpgradeProductPhaseRequest;
}());
exports.UpgradeProductPhaseRequest = UpgradeProductPhaseRequest;
var CreateDeliverableMessageRequest = /** @class */ (function () {
    function CreateDeliverableMessageRequest() {
    }
    return CreateDeliverableMessageRequest;
}());
exports.CreateDeliverableMessageRequest = CreateDeliverableMessageRequest;
var AdjustWorkSlotRequest = /** @class */ (function () {
    function AdjustWorkSlotRequest() {
    }
    return AdjustWorkSlotRequest;
}());
exports.AdjustWorkSlotRequest = AdjustWorkSlotRequest;
var AddAssetOutcomeRequest = /** @class */ (function () {
    function AddAssetOutcomeRequest() {
    }
    return AddAssetOutcomeRequest;
}());
exports.AddAssetOutcomeRequest = AddAssetOutcomeRequest;
var MoveDeliverableRequest = /** @class */ (function () {
    function MoveDeliverableRequest() {
    }
    return MoveDeliverableRequest;
}());
exports.MoveDeliverableRequest = MoveDeliverableRequest;
var SwitchProductRequest = /** @class */ (function () {
    function SwitchProductRequest() {
    }
    return SwitchProductRequest;
}());
exports.SwitchProductRequest = SwitchProductRequest;
var SetContractualEndDateRequest = /** @class */ (function () {
    function SetContractualEndDateRequest() {
    }
    return SetContractualEndDateRequest;
}());
exports.SetContractualEndDateRequest = SetContractualEndDateRequest;
var SwitchContractTypeRequest = /** @class */ (function () {
    function SwitchContractTypeRequest() {
    }
    return SwitchContractTypeRequest;
}());
exports.SwitchContractTypeRequest = SwitchContractTypeRequest;
var SwitchOrganizationTypeRequest = /** @class */ (function () {
    function SwitchOrganizationTypeRequest() {
    }
    return SwitchOrganizationTypeRequest;
}());
exports.SwitchOrganizationTypeRequest = SwitchOrganizationTypeRequest;
var AdjustContractRolesRequest = /** @class */ (function () {
    function AdjustContractRolesRequest() {
    }
    return AdjustContractRolesRequest;
}());
exports.AdjustContractRolesRequest = AdjustContractRolesRequest;
var AdjustProductLineRolesRequest = /** @class */ (function () {
    function AdjustProductLineRolesRequest() {
    }
    return AdjustProductLineRolesRequest;
}());
exports.AdjustProductLineRolesRequest = AdjustProductLineRolesRequest;
var AdjustHeadRolesRequest = /** @class */ (function () {
    function AdjustHeadRolesRequest() {
    }
    return AdjustHeadRolesRequest;
}());
exports.AdjustHeadRolesRequest = AdjustHeadRolesRequest;
var AdjustLineRolesRequest = /** @class */ (function () {
    function AdjustLineRolesRequest() {
    }
    return AdjustLineRolesRequest;
}());
exports.AdjustLineRolesRequest = AdjustLineRolesRequest;
var ConfirmProvisionalLineRequest = /** @class */ (function () {
    function ConfirmProvisionalLineRequest() {
    }
    return ConfirmProvisionalLineRequest;
}());
exports.ConfirmProvisionalLineRequest = ConfirmProvisionalLineRequest;
var RenamePhaseRequest = /** @class */ (function () {
    function RenamePhaseRequest() {
    }
    return RenamePhaseRequest;
}());
exports.RenamePhaseRequest = RenamePhaseRequest;
var ToBeScheduledRequest = /** @class */ (function () {
    function ToBeScheduledRequest() {
    }
    return ToBeScheduledRequest;
}());
exports.ToBeScheduledRequest = ToBeScheduledRequest;
var ConfirmScheduleRequest = /** @class */ (function () {
    function ConfirmScheduleRequest() {
    }
    return ConfirmScheduleRequest;
}());
exports.ConfirmScheduleRequest = ConfirmScheduleRequest;
var TransferContractLineRequest = /** @class */ (function () {
    function TransferContractLineRequest() {
    }
    return TransferContractLineRequest;
}());
exports.TransferContractLineRequest = TransferContractLineRequest;
var CreateFullAccountSetupRequest = /** @class */ (function () {
    function CreateFullAccountSetupRequest() {
        this.ownerId = 19;
        this.accountManagerId = 2197;
    }
    return CreateFullAccountSetupRequest;
}());
exports.CreateFullAccountSetupRequest = CreateFullAccountSetupRequest;
var CreateFullSOWSetupRequest = /** @class */ (function () {
    function CreateFullSOWSetupRequest() {
        this.ownerId = 19;
        this.accountManagerId = 2197;
    }
    return CreateFullSOWSetupRequest;
}());
exports.CreateFullSOWSetupRequest = CreateFullSOWSetupRequest;
var RequestClientReportRequest = /** @class */ (function () {
    function RequestClientReportRequest() {
    }
    return RequestClientReportRequest;
}());
exports.RequestClientReportRequest = RequestClientReportRequest;
